import styled from 'styled-components'

export const TabContainer = styled.div`
    min-width: 220px;
`
